module.exports = __webpack_public_path__ + "img/radio-waves.653cf6ea.svg";